import React from 'react';
import {
  Button,
  Box,
  Divider,
  Stack,
  ListSubheader,
  IconButton
} from '@mui/material';
import PropTypes from 'prop-types';
import { BodyLarge } from 'components/common_v2/typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear } from '@fortawesome/free-solid-svg-icons';
import getText from 'context/language/getText';

export const NotificationsHeader = ({
  onMarkAllNotificationsReadClick,
  onSettingsClick,
}) => (
  <ListSubheader component="div" id="nested-list-subheader" disableGutters>
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      p={1}
    >
      <BodyLarge className="bold">
        {getText('header.notifications.labels.title')}
      </BodyLarge>
      <Stack direction="row" spacing={1}>
        <Button
          key="mark-all-as-read"
          variant="text"
          color="inherit"
          onClick={onMarkAllNotificationsReadClick}
          data-test-id="notifications__notification-mark-all-as-read"
        >
          {getText('header.notifications.buttons.markAllAsRead')}
        </Button>
        <IconButton
          aria-label="Notifications"
          variant="contained"
          onClick={onSettingsClick}
          data-test-id="notifications__notification-settings"
        >
          <FontAwesomeIcon icon={faGear} color="black" size="xs" />
        </IconButton>
      </Stack>
    </Box>
    <Divider />
  </ListSubheader>
);

NotificationsHeader.propTypes = {
  onMarkAllNotificationsReadClick: PropTypes.func.isRequired,
  onSettingsClick: PropTypes.func.isRequired,
};
